import {scaleTime, scaleUtc, ScaleTime, ScaleLinear} from 'd3'
import {useMemo} from 'react'

import type {MomentRange, NumberRange} from '../selectors/time'

export type BaseScaleFnType = number

export type TimeScaleFn<
  Range extends BaseScaleFnType = BaseScaleFnType,
  Output = Range,
  Unknown = never
> = ScaleTime<Range, Output, Unknown>

export type LinearScaleFn<
  Range extends BaseScaleFnType = BaseScaleFnType,
  Output = Range,
  Unknown = never
> = ScaleLinear<Range, Output, Unknown>

interface GetDateScaleParams {
  domain: MomentRange
  range: NumberRange
  isUTC?: boolean
}

export const getDateScale = ({domain, range, isUTC = false}: GetDateScaleParams) =>
  (isUTC ? scaleUtc : scaleTime)().domain(domain).range(range)

export const useDateScale = ({
  range: [rangeStart, rangeEnd],
  domain: [domainStart, domainEnd],
  isUTC = false
}: GetDateScaleParams) =>
  useMemo(
    () => getDateScale({range: [rangeStart, rangeEnd], domain: [domainStart, domainEnd], isUTC}),
    [rangeStart, rangeEnd, domainStart, domainEnd, isUTC]
  )
